import PropTypes from "prop-types";
import React from "react";
import TemperatureLineChart from "./TemperatureLineChart";

function TemperatureChart({ temperatureData }) {
  return <TemperatureLineChart temperatureData={temperatureData} />;
}

TemperatureChart.propTypes = {
  temperatureData: PropTypes.shape({
    range: PropTypes.string,
    data_points: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        distal: PropTypes.number,
        central: PropTypes.number,
        proximal: PropTypes.number,
        type: PropTypes.string,
      })
    ),
  }),
};

TemperatureChart.defaultProps = {
  temperatureData: {
    range: "day",
    data_points: [],
  },
};

export default TemperatureChart;
